import type { CheckVehicleResponse } from '@local/common-lib';
import { useFormik } from 'formik';
import type { FC } from 'react';
import type { CheckVehicleForm } from './vehicle-check.view.js';
import { VehicleCheckView } from './vehicle-check.view.js';

export interface VehicleCheckProps {
  checkVehicle: (rego: string) => Promise<void>;
  removeVehicle: (rego: string) => void;
  vehicles: CheckVehicleResponse[];
}

export const VehicleCheck: FC<VehicleCheckProps> = ({
  checkVehicle,
  removeVehicle,
  vehicles,
}) => {
  const form = useFormik<CheckVehicleForm>({
    initialValues: { rego: '' },
    onSubmit: async (values) => {
      await form.setFieldValue('rego', '');

      if (!values.rego) return;
      if (vehicles.some((v) => v.rego === values.rego)) return;

      await checkVehicle(values.rego);
    },
  });

  return (
    <VehicleCheckView
      form={form}
      onVehicleRemove={removeVehicle}
      vehicles={vehicles}
    />
  );
};
